import { Helmet } from 'react-helmet-async';
import { Typography } from 'components';
import styles from './OfflinePSD2Verified.module.scss';
import { useTranslation } from 'react-i18next';

export default function OfflinePSD2Verified() {
  const { t } = useTranslation();
  const searchParams = new URLSearchParams(window.location.search);
  // NOTE: possible options should be [DONE, ERROR, NAME_SURNAME_MISMATCH]
  const resultStatus = searchParams.get('status') || '';

  let psdResultMessageKey: string;

  if (resultStatus === 'DONE') {
    psdResultMessageKey = 'offline_psd:result.DONE';
  } else {
    psdResultMessageKey = 'offline_psd:result.ERROR';
  }

  return (
    <>
      <Helmet>
        <title>{t('psd2_verified:html_title')}</title>
      </Helmet>

      <div data-test="psd-result-card" className={styles.card}>
        <Typography
          className={styles.title}
          kind="h1"
          size="l"
          dataTest="psd2-verified-title"
        >
          {t(`${psdResultMessageKey}.title`)}
        </Typography>
        <Typography
          className={styles.title}
          kind="p"
          size="s"
          dataTest="psd2-verified-subtitle"
        >
          {t(`${psdResultMessageKey}.subtitle`)}
        </Typography>
      </div>
    </>
  );
}
